/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

class ApiErrorModel {
  constructor(apiResponse) {
    this.response = apiResponse;
    this.data = _.get(apiResponse, 'response.body', {});
  }

  messageKey() {
    return this.data.key;
  }

  status() {
    return this.response.status;
  }

  isUnauthorized() {
    return this.response.status === 401;
  }

  isForbidden() {
    return this.response.status === 403;
  }

  isNotFound() {
    return this.response.status === 404;
  }

  isConflict() {
    return this.response.status === 409;
  }

  isLocked() {
    return this.response.status === 423;
  }

  isUnavailableForLegalReasons() {
    return this.response.status === 451;
  }

  responseMessage() {
    return this.response.status ? `${this.response.status}: ${this.response.message}` : this.response.message;
  }

}

export default ApiErrorModel;
